// adding rx operators
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/finally';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/let';
import 'rxjs/add/operator/startWith';

import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';

import 'rxjs/ReplaySubject';
import 'rxjs/Observable';
import 'rxjs/Subject';
import 'rxjs/Subscription';



// WEBPACK FOOTER //
// ./src/app/application/rxjs.imports.ts